import { gql } from '@apollo/client'

export const GET_CLIENTS = gql`
  query {
    getClients {
      id
      name
      description
      metadata
    }
  }
`

export const GET_CLIENT = gql`
  query ($orgCode: String!) {
    getClient(orgCode: $orgCode) {
      id
      name
      description
      metadata
    }
  }
`

export const GET_LOGGED_IN_USER = gql`
  query {
    getLoggedInUser {
      id
      isActive
      profile {
        id
        email
        firstName
        lastName
        mobile
      }
      groups {
        id
        name
        description
      }
      roles {
        id
        name
        description
        isActive
      }
      userPermissions {
        id
        name
        description
        createdAt
      }
      applications {
        id
        name
        description
        clients {
          id
          name
          description
        }
      }
    }
  }
`

export const GET_RESOURCES = gql`
  query ($clientId: UUID!, $resourceType: ResourceTypeEnum!) {
    getResources(input: { clientId: $clientId, resourceType: $resourceType }) {
      id
      resourceKey
      versions {
        id
        version
        comments
        createdAt
        updatedAt
        pipelineStatus {
          stage
          status
        }
      }
    }
  }
`

export const GET_TASKS = gql`
  query (
    $clientId: UUID!
    $resourceType: ResourceTypeEnum!
    $limit: Int!
    $offset: Int!
    $commaSeparatedProvidedIds: String
  ) {
    getTasks(
      input: {
        clientId: $clientId
        resourceType: $resourceType
        pagination: { limit: $limit, offset: $offset }
        filters: { commaSeparatedProvidedIds: $commaSeparatedProvidedIds }
      }
    ) {
      id
      resource {
        id
        resourceKey
        workflowStates {
          stage
          status
          resourceVersion
          displayStatus
          errors
        }
        versions {
          id
          version
          comments
          createdAt
          updatedAt
          pipelineStatus {
            stage
            status
          }
        }
      }
      assignedToUser {
        id
        isActive
        profile {
          id
          email
          firstName
          lastName
          mobile
        }
        groups {
          id
          name
          description
        }
        roles {
          id
          name
          description
          isActive
        }
        userPermissions {
          id
          name
          description
          createdAt
        }
        applications {
          id
          name
          description
          clients {
            id
            name
            description
          }
        }
      }
      assignedToGroup {
        id
        name
        description
      }
      locked
      createdAt
      updatedAt
    }
  }
`

export const GET_RESOURCE = gql`
  query ($resourceId: UUID!) {
    getResource(input: { resourceId: $resourceId }) {
      id
      resourceKey
      versions {
        id
        version
        comments
        createdAt
        updatedAt
        pipelineStatus {
          stage
          status
        }
      }
    }
  }
`

export const GET_TASK = gql`
  query ($taskId: UUID!) {
    getTask(input: { taskId: $taskId }) {
      id
      resource {
        id
        resourceKey
        versions {
          id
          version
          comments
          createdAt
          updatedAt
          createdBy {
            id
            profile {
              id
              email
            }
          }
          pipelineStatus {
            stage
            status
          }
        }
      }
      assignedToUser {
        id
        isActive
        profile {
          id
          email
          firstName
          lastName
          mobile
        }
        groups {
          id
          name
          description
        }
        roles {
          id
          name
          description
          isActive
        }
        userPermissions {
          id
          name
          description
          createdAt
        }
        applications {
          id
          name
          description
          clients {
            id
            name
            description
          }
        }
      }
      assignedToGroup {
        id
        name
        description
      }
      locked
      createdAt
      updatedAt
    }
  }
`

export const DOWNLOAD_RESOURCE = gql`
  query ($input: [DownloadResourceInput!]!) {
    downloadResource(input: $input) {
      fileName
      preSignedUri
      expirationTime
    }
  }
`

export const GET_ASSIGNEE_USER_GROUPS = gql`
  query ($assignedToGroupId: UUID) {
    getAllowedTaskAssignments(input: { assignedToGroupId: $assignedToGroupId }) {
      group {
        id
        name
      }
      users {
        id
        isActive
        profile {
          id
          email
          firstName
          lastName
          mobile
        }
        groups {
          id
          name
          description
        }
        roles {
          id
          name
          description
          isActive
        }
        userPermissions {
          id
          name
          description
          createdAt
        }
        applications {
          id
          name
          description
          clients {
            id
            name
            description
          }
        }
      }
    }
  }
`
